'use client';

import { useTranslations } from 'next-intl';

import { IconServiceTBank } from '@/icon/service/TBank';
import { UiKitAccordion } from '@/ui-kit/accordion';
import { UiKitButton } from '@/ui-kit/button';

import { styles } from './OauthMethods.styles';

const isExternalAuthEnabled = () => {
  const value =
    typeof window !== 'undefined'
      ? window.__ENV__?.EXTERNAL_AUTH_ENABLED
      : process.env.EXTERNAL_AUTH_ENABLED;

  return Boolean(value);
};

interface OauthMethodsProps {
  placement: 'header' | 'cart';
  redirectUrl?: string;
  className?: string;
}

export function OauthMethods({ placement, redirectUrl, className }: OauthMethodsProps) {
  const t = useTranslations();
  const slots = styles();

  if (!isExternalAuthEnabled()) return null;

  return (
    <div className={slots.base({ className })}>
      <UiKitAccordion
        className={slots.accordion()}
        headerClassName={slots.accordionHeader()}
        headerIconWrapperClassName={slots.accordionHeaderIconWrapper()}
        contentClassName={slots.accordionContentWrapper()}
        defaultActiveIndexes={[0]}
        items={[
          {
            header: (
              <div className={slots.header()}>{t('login.otherAuthorizationMethods')}</div>
            ),
            content: (
              <div className={slots.content()}>
                <UiKitButton
                  color="surface"
                  rounded="full"
                  className={slots.button()}
                  onClick={() => {
                    window.sessionStorage.setItem('oauth:tbank:placement', placement);
                    if (redirectUrl) {
                      window.sessionStorage.setItem(
                        'oauth:tbank:redirectUrl',
                        redirectUrl
                      );
                    } else {
                      window.sessionStorage.removeItem('oauth:tbank:redirectUrl');
                    }
                    window.location.assign('/oauth/tid');
                  }}
                >
                  <div className={slots.buttonContent()}>
                    <IconServiceTBank className={slots.buttonIcon()} />
                    T-ID
                  </div>
                </UiKitButton>
              </div>
            )
          }
        ]}
      />
    </div>
  );
}
